export enum PersistentLogLevelEnum {
  Verbose,
  Debug,
  Information,
  Warning,
  Error,
  Fatal,
}
